import { createRouter as createVueRouter, createWebHistory } from 'vue-router';
import AccountManagementIndex from '@/pages/index.vue';
// NOTE: The inquiry screen is not needed in the account application, so this code is commented out.
// import Inquiry from '@/pages/others/index.vue';
import UserLogin from '@/pages/UserLogin.vue';
import { resolvePageTitle } from '@/common/resolvePageTitle';
import { authGuard } from '@auth0/auth0-vue';

declare module 'vue-router' {
  interface RouteMeta {
    /** i18n key of the browser tab title; omit to use the app title */
    titleKey?: string;
  }
}

export function createRouter() {
  const routes = [
    {
      path: '/',
      name: 'AccountManagementIndex',
      beforeEnter: authGuard,
      component: AccountManagementIndex,
      meta: { titleKey: 'userInfo.title' },
    },
    // NOTE: The inquiry screen is not needed in the account application, so this code is commented out.
    // {
    //   path: '/other/inquiry',
    //   name: 'Inquiry',
    //   beforeEnter: authGuard,
    //   component: Inquiry,
    //   meta: { titleKey: 'inquiry.title' },
    // },
    {
      path: '/login',
      name: 'UserLogin',
      component: UserLogin,
    },
  ];
  const router = createVueRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
  });

  // NOTE: beforeEachやbeforeEnterでauthGuardの直後にgetUserRoleをしてもundefinedになってしまうため,
  // beforeEachでauthGuardを実行してbeforeEnterでgetUserRoleを実行している
  router.beforeEach(async (to, _from, next) => {
    await authGuard(to);
    next();
  });

  // ブラウザタブのタイトルを画面のロケール表示名に合わせる
  router.afterEach((to) => {
    document.title = resolvePageTitle(to);
  });

  return router;
}
